module.exports = __webpack_public_path__ + "static/media/20170806_02day_0049AT.b71bb188.jpg";